// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
// Describes the navigation hierarchy of the accounting section. Drives the
// hover dropdown attached to the "Accounting" crumb in ReportBreadcrumbs so
// the breadcrumb trail doubles as a quick-jump nav within the section.
import { BreadcrumbNavSection } from '@/components/section-breadcrumbs';

// Sections that live beneath the accounting hub at /accounting, mirroring the
// navigable surfaces shown on the accounting landing page. The dropdown groups
// destinations under the same headings the landing page uses so users can scan
// the menu by intent — snapshots, rollforwards and bridges, and close
// management. Tabbed report routes collapse to a single entry pointing at their
// primary tab, and the cross-section configuration links live elsewhere so they
// are omitted here.
const ACCOUNTING_NAV_SECTIONS: BreadcrumbNavSection[] = [
  {
    heading: 'Setup and snapshots',
    items: [
      {
        label: 'Asset snapshot report',
        to: '/reports/asset-snapshot/inventory',
      },
    ],
  },
  {
    heading: 'Rollforwards and bridges',
    items: [
      {
        label: 'Asset rollforward report',
        to: '/reports/asset-rollforward/inventory',
      },
      { label: 'Depreciation schedule', to: '/reports/depreciation-schedule' },
      { label: 'Asset bridge report', to: '/reports/asset-bridge/inventory' },
    ],
  },
  {
    heading: 'Close management',
    items: [
      { label: 'Asset exception report', to: '/reports/exception/asset/date' },
      { label: 'Initial true-up', to: '/accounting/initial-true-up' },
      { label: 'Close workflow', to: '/accounting/close-workflow' },
      { label: 'Prior periods', to: '/accounting/period-review' },
    ],
  },
];

// Returns the section list for an accounting breadcrumb label, or undefined
// when the label is a leaf (no nested options to surface).
export function findAccountingNavChildren(
  label: string
): BreadcrumbNavSection[] | undefined {
  if (label === 'Accounting') {
    return ACCOUNTING_NAV_SECTIONS;
  }
  return undefined;
}
